export const ROUTES_APPLICATION_PATH = Object.freeze({
  HOME: {
    BASE_URL: "/home"
  },
  ACTIONS: {
    BASE_URL: "/acoes",
    COMPONENT_URL: [
      "/acoes/pedidos",
      "/acoes/historico",
      "/acoes/unidades",
      "/acoes/balanco-colecoes"
    ],
    ROUTE_SEGMENT: [
      "/pedidos",
      "/historico",
      "/unidades",
      "/balanco-colecoes"
    ]
  },
  ANALYSIS: {
    BASE_URL: "/analise",
    COMPONENT_URL: ["/analise/plano", "/analise/assertividade"],
    ROUTE_SEGMENT: ["/plano", "/assertividade"]
  },
  OPPORTUNITIES: {
    BASE_URL: "/oportunidades",
    COMPONENT_URL: ["/oportunidades/produtos", "/oportunidades/checkout", "/oportunidades/produtos-detalhado"],
    ROUTE_SEGMENT: ["/produtos", "/checkout", "/produtos-detalhado"]
  },
  SETTINGS: {
    BASE_URL: "/configuracoes/*"
  },
  PRODUCTS: {
    BASE_URL: "/produtos",
    COMPONENT_URL: [
      "/produtos/analise-desempenho",
      "/produtos/ajustes-otb",
      "/produtos/ajustes-abastecimento",
      "/produtos/planejamento",
      "/produtos/plano-compra",
      "/produtos/otb",
      "/produtos/analytics"
    ],
    ROUTE_SEGMENT: [
      "/analise-desempenho",
      "/ajustes-otb",
      "/ajustes-abastecimento",
      "/planejamento",
      "/plano-compra",
      "/otb",
      "/analytics"
    ]
  },
  ASSORTMENT: {
    BASE_URL: "/acoes/balanco-colecoes"
  },
  SORTIMENTO: {
    BASE_URL: "/sortimento",
    COMPONENT_URL: [
      "/sortimento/opcoes",
      "/sortimento/qualificacao-mix",
      "/sortimento/oportunidades",
      "/sortimento/mercados-conveniencias"
    ],
    ROUTE_SEGMENT: [
      "/qualificacao-mix",
      "/oportunidades",
      "/mercados-conveniencias"
    ]
  },
  PURCHASE_QUALITY: {
    BASE_URL: "/compra",
    COMPONENT_URL: ["/compra/qualidade"],
    ROUTE_SEGMENT: ["/qualidade"]
  },
  DATA_INTEGRATION: {
    BASE_URL: "/integracao-dados"
  },

})
